export const PERMISSIONS = {
  SERVICES_REPORT: 1,
  DOWNLOAD_REPORTS: 2,
  UPLOAD_SALE: 3,
  ASSIGNMENT: 4,
  CATALOGS: 5,
  ASSIGNMENT_BY_DRIVER: 6,
  WEEKLY_PRODUCTION_REPORT: 7,
  DRIVER_REPORT: 8,
  DRIVER_PAYMENT_REPORT: 9,
  INCOME_REEPORT: 10,
  MAINTENANCE_LOG_REPORT: 11,
  ADD_EDIT_MAINTENANCE_LOG: 12,
  MAINTENANCE_CATALOGS: 13,
  ROUTES_REPORT: 14,
  PAYMENT_ORDER_REPORT: 15,
  ROUTES_REPORT_BY_STATUS: 16,
  METRICS_REPORT: 17
}
